var _g, _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVilShareWithHcf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_3442_73735)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "#3E74B5",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 39,
    fill: "#2B67AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7 33V37.8752C56.5586 37.8752 54.9274 39.5097 58.1688 39.5097H59.8V34.6345H58.1688C54.9274 34.6345 56.5586 33 51.7 33ZM38.9313 41.8486C38.5024 41.9296 38.193 42.3101 38.2 42.7504V47.2593H31.9C31.8719 47.2593 31.8438 47.2593 31.8157 47.2593C31.3516 47.3015 30.9965 47.6925 31 48.161V67.0982C31 67.5949 31.4043 68 31.9 68H75.1C75.5957 68 76 67.5949 76 67.0982V48.161C76 47.6644 75.5957 47.2593 75.1 47.2593H68.8V42.7504C68.8 42.2537 68.3957 41.8486 67.9 41.8486H39.1C39.0719 41.8486 39.0438 41.8486 39.0156 41.8486C38.9875 41.8486 38.9594 41.8486 38.9313 41.8486ZM40 43.6522H67V47.2593H40V43.6522ZM32.8 49.0628H74.2V66.1965H32.8V49.0628ZM36.4 51.7681V56.277H39.1V51.7681H36.4ZM42.7 51.7681V56.277H45.4V51.7681H42.7ZM49 51.7681V56.277H51.7V51.7681H49ZM55.3 51.7681V56.277H58V51.7681H55.3ZM61.6 51.7681V56.277H64.3V51.7681H61.6ZM67.9 51.7681V56.277H70.6V51.7681H67.9ZM36.4 58.9823V63.4911H39.1V58.9823H36.4ZM42.7 58.9823V63.4911H45.4V58.9823H42.7ZM49 58.9823V63.4911H51.7V58.9823H49ZM55.3 58.9823V63.4911H58V58.9823H55.3ZM61.6 58.9823V63.4911H64.3V58.9823H61.6ZM67.9 58.9823V63.4911H70.6V58.9823H67.9Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_3442_73735",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3442_73735"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3442_73735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3442_73735",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect2_foregroundBlur_3442_73735"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVilShareWithHcf);
export default __webpack_public_path__ + "static/media/VilShareWithHCF.d88bf32904987c31cfc54aba488eb5f8.svg";
export { ForwardRef as ReactComponent };